module.exports = __webpack_public_path__ + "img/room.33776568.jpeg";